module.exports = __webpack_public_path__ + "img/low-liquidity-disable.4a773b04.svg";